import React, { useState } from 'react';
import './hambur.css';
import { useNavigate } from 'react-router-dom';

function Hambur({ theme }) {
  const [active, setActive] = useState('');
  const [menuOpen, setMenuOpen] = useState(false);

  function hamActive() {
    setActive((prev) => (prev ? '' : 'ham-active'));
    setMenuOpen(!menuOpen);
  }


  const navigate = useNavigate();

  const themes = {
    dark: {
      bgColor: 'white',
    },

    light: {
      bgColor: 'rgba(0, 0, 0, 0.6)',
    },
  };

  return (
    <>
      <div className={`hambar ${active}`} onClick={() => hamActive()}>
        <div
          style={{
            backgroundColor: menuOpen
              ? 'rgba(74, 144, 226, 0.8)'
              : themes[theme].bgColor,
            borderRadius: '4px',
          }}
        ></div>
        <div
          style={{
            backgroundColor: menuOpen
              ? 'rgba(74, 144, 226, 0.8)'
              : themes[theme].bgColor,
            borderRadius: '4px',
          }}
        ></div>
        <div
          style={{
            backgroundColor: menuOpen
              ? 'rgba(74, 144, 226, 0.8)'
              : themes[theme].bgColor,
            borderRadius: '4px',
          }}
        ></div>
      </div>
      <div className={`${active}-ham-menu-list ham-menu-side glass-mobile-menu`}>
        <div
          className="ham-item glass-menu-item"
          onClick={() => {
            navigate('/');
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }}
        >
          Home
        </div>
        <div className="ham-item glass-menu-item" onClick={() => navigate('/applestore')}>
          Apple
        </div>
        <div className="ham-item glass-menu-item" onClick={() => navigate('/samsungStore')}>
          Samsung
        </div>
        <div className="ham-item glass-menu-item" onClick={() => navigate('/oneplusstore')}>
          OnePlus
        </div>
        {/* <div className="ham-accessories ham-item glass-menu-item" onClick={() => accessories()}>
          Accessories{' '}
          <div className={`ham-accessories-arrow ${access}-ham-arrow-up`}>
            {'>'}
          </div>
        </div>
        <div className={`access ${access}`}>
          <div
            className="access-ham-item glass-menu-item-sub"
            onClick={() => navigate('/marshall')}
          >
            Marshall
          </div>
          <div className="access-ham-item glass-menu-item-sub" onClick={() => navigate('/muvtech')}>
            Muvtech
          </div>
        </div> */}
        <div className="ham-item glass-menu-item" onClick={() => navigate('/accessories')}>
          Accessories
        </div>
        <div className="ham-nav-buttons">
          <div className="ham-btn ham-btn-about" onClick={() => navigate('/aboutus')}>
            About us
          </div>
          <div className="ham-btn ham-btn-contact" onClick={() => navigate('/contactus')}>
            Contact us
          </div>
        </div>
      </div>
    </>
  );
}

export default Hambur;
